import PropTypes from 'prop-types';
import { useDispatch } from 'react-redux';

// material-ui
import { useTheme } from '@mui/material/styles';
import {
  Button,
  DialogActions,
  DialogContent,
  DialogTitle,
  Divider,
  Grid,
  Stack,
  Typography,
} from '@mui/material';
import { LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';

// third-party
import _ from 'lodash';

import { openSnackbar } from 'store/reducers/snackbar';


import useAuth from 'hooks/useAuth';
import { useState } from 'react';
import { blockUserRequest } from 'store/reducers/access';
import { useTranslation } from 'react-i18next';

// ==============================|| CUSTOMER ADD / EDIT / DELETE ||============================== //

const BlockUser = ({ customer, onCancel, onSaved }) => {
  const theme = useTheme();
  const context = useAuth();
  const dispatch = useDispatch();
  const [t, i18n] = useTranslation();
  const isBlocking = customer?.status != 'BANNED';
  const [isSubmitting, setSubmitting] = useState(false);

  const successMessage = (isBlocking) ? t('user_blocked') : t('user_unblocked');

  const handleSubmit = () => {
    setSubmitting(true);
    const token = context.user?.token;
    const values = {token: token, id: customer.id};
    dispatch(blockUserRequest(values)).unwrap().then(res => {
      setSubmitting(false);
      if(res.success) {
        dispatch(openSnackbar({open: true, message: successMessage, variant: 'alert', alert: {color: 'success'}, close: false}));
        onCancel();
        if(onSaved) {
          onSaved();
        }
      }
      else {
        dispatch(openSnackbar({open: true, message: 'Error: '+res.messages?.[0], variant: 'alert', alert: {color: 'error'}, close: false}));
      }
    });
  }

  const title = (isBlocking) ? t('block_user') : t('unblock_user');
  const action = (isBlocking) ? t('block') : t('unblock');
  const confirmText = <div dangerouslySetInnerHTML={
    {
      __html: (isBlocking) ? t('block_confirm', {interpolation: {escapeValue: false}}) : t('unblock_confirm', {interpolation: {escapeValue: false}})
    }
  } />;
  return (
    <LocalizationProvider dateAdapter={AdapterDateFns}>
        <DialogTitle>{title}</DialogTitle>
          <Divider />
          <DialogContent sx={{ p: 2.5 }}>
            <Grid container spacing={3}>
              <Grid item xs={12} md={12}>
                <Typography variant='body'>{confirmText}</Typography>
              </Grid>
            </Grid>
          </DialogContent>
          <Divider />
          <DialogActions sx={{ p: 2.5 }}>
            <Grid container justifyContent="space-between" alignItems="center">
              <Grid item></Grid>
              <Grid item>
                <Stack direction="row" spacing={2} alignItems="center">
                  <Button color="error" onClick={onCancel}>
                    {t('cancel')}
                  </Button>
                  <Button type="submit" variant="contained" disabled={isSubmitting} onClick={handleSubmit}>{action}</Button>
                </Stack>
              </Grid>
            </Grid>
          </DialogActions>

      </LocalizationProvider>
  );
};

export default BlockUser;
